// Configuration for all send pages
export const SEND_CONFIGS = {
  campaign: {
    itemName: "campaign",
    itemLabel: "Campaign ID",
    itemIdField: "campaignid",
    itemDisplayField: "campaignname",
    itemApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/CampaignOperation/GetDistinct/campaignname_active",
    singleApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/Campaign",
    groupApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/Campaign",
    singleTitle: "Send Campaign",
    groupTitle: "Send Campaign to SubGroup",
    singleButtonText: "Send Campaign",
    groupButtonText: "Send Campaign to SubGroup",
  },
  audio: {
    itemName: "audio",
    itemLabel: "Audio ID",
    itemIdField: "audioid",
    itemDisplayField: "audioname",
    itemApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/Audio",
    groupApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/Audio",
    singleTitle: "Send Audio",
    groupTitle: "Send Audio to SubGroup",
    singleButtonText: "Send Audio",
    groupButtonText: "Send Audio to SubGroup",
  },
  audioPack: {
    itemName: "audio pack",
    itemLabel: "Audio Pack ID",
    itemIdField: "audiopackid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/AudioPackOperation/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/AudioPack",
    groupApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/AudioPack",
    singleTitle: "Send Audio Pack",
    groupTitle: "Send Audio Pack to SubGroup",
    singleButtonText: "Send Audio Pack",
    groupButtonText: "Send Audio Pack to SubGroup",
  },
  catalog: {
    itemName: "Catalogue",
    itemLabel: "Catalogue ID",
    itemIdField: "catalogid",
    itemDisplayField: "Cataloguename",
    itemApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/CatalogOperation/GetDistinct/catalogname_active",
    singleApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/Catalog",
    groupApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/Catalog",
    singleTitle: "Send Catalogue",
    groupTitle: "Send Catalogue to SubGroup",
    singleButtonText: "Send Catalogue",
    groupButtonText: "Send Catalogue to SubGroup",
    deleteApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/Delete/Catalog",
    deleteAllApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/DeleteAll/Catalog",
    groupDeleteApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/Delete/Catalog",
    groupDeleteAllApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/DeleteAll/Catalog",
    deleteLevelApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/Delete/Catalog/LevelId",
    groupDeleteLevelApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/Delete/Catalog/LevelId",
    showLevels: true,
  },
  schedule: {
    itemName: "schedule",
    itemLabel: "Schedule ID",
    itemIdField: "schedulerid",
    itemDisplayField: "schedulername",
    itemApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/CatalogSchedulerOperation/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/CatalogScheduler",
    groupApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/CatalogScheduler",
    singleTitle: "Send Schedule",
    groupTitle: "Send Schedule to SubGroup",
    singleButtonText: "Send Schedule",
    groupButtonText: "Send Schedule to SubGroup",
  },
  firmware: {
    itemName: "firmware",
    itemLabel: "Firmware ID",
    itemIdField: "Firmwareid",
    itemDisplayField: "firmwarename",
    itemApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/FirmwareOperation/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/Firmware",
    groupApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/Firmware",
    singleTitle: "Send Firmware",
    groupTitle: "Send Firmware to SubGroup",
    singleButtonText: "Send Firmware",
    groupButtonText: "Send Firmware to SubGroup",
  },
  htmlDoc: {
    itemName: "htmldoc",
    itemLabel: "HTML Doc ID",
    itemIdField: "htmldocid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/HtmlDocOperation/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/HtmlDoc",
    groupApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/HtmlDoc",
    singleTitle: "Send HTML Doc",
    groupTitle: "Send HTML Doc to SubGroup",
    singleButtonText: "Send HTML Doc",
    groupButtonText: "Send HTML Doc to SubGroup",
  },
  htmlDocZip: {
    itemName: "htmldoczip",
    itemLabel: "HTML Doc Zip ID",
    itemIdField: "htmldoczipid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/HtmlDocZipOperation/Search",
    singleApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/HtmlDocZip",
    groupApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/HtmlDocZip",
    singleTitle: "Send HTML Doc Zip",
    groupTitle: "Send HTML Doc Zip to SubGroup",
    singleButtonText: "Send HTML Doc Zip",
    groupButtonText: "Send HTML Doc Zip to SubGroup",
    isPostSearch: true
  },
  dqrImage: {
    itemName: "dqr image",
    itemLabel: "DQR Image ID",
    itemIdField: "dqrimageid",
    itemDisplayField: "imagename",
    itemApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/DQROperation/GetDistinct/dqrname_active",
    singleApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/DqrImage",
    groupApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/DqrImage",
    singleTitle: "Send DQR Image",
    groupTitle: "Send DQR Image to SubGroup",
    singleButtonText: "Send DQR Image",
    groupButtonText: "Send DQR Image to SubGroup",
  },
  awsIotCore: {
    itemName: "AWS IoT Core",
    itemLabel: "AWS IoT Core ID",
    itemIdField: "AWSIOTCoreid",
    itemDisplayField: "deviceid",
    itemApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/AWSIOTCoreSettingOperation/Search",
    singleApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/AWSIOTCore",
    groupApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/AWSIOTCore",
    singleTitle: "Send AWS IoT Core",
    groupTitle: "Send AWS IoT Core to SubGroup",
    singleButtonText: "Send AWS IoT Core",
    groupButtonText: "Send AWS IoT Core to SubGroup",
    isPostSearch: true
  },
  jsonSetting: {
    itemName: "json setting",
    itemLabel: "Json Setting ID",
    itemIdField: "jsonsettingid",
    itemDisplayField: "settingname",
    itemApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/JsonSettingOperation/Search",
    singleApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/JsonSetting",
    groupApiUrl: "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/JsonSetting",
    singleTitle: "Send Json Setting",
    groupTitle: "Send Json Setting to SubGroup",
    singleButtonText: "Send Json Setting",
    groupButtonText: "Send Json Setting to SubGroup",
    isPostSearch: true
  },
};

// Helper function to get config by type
export const getSendConfig = (type) => {
  return SEND_CONFIGS[type];
};
